import React, { useEffect, useState } from 'react'
import { Link, useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import * as CONSTANTS from "../CONSTANTS";
import SideFilter from '../components/sideline/SideFilter';

function ShopScreen() {

  const [listProducts, setListProducts]                                   = useState([]);
  const [startLimit, setStartLimit]                                       = useState(500); 
  const [endLimit, setEndLimit]                                           = useState(8000);

  const [minRange, setMinRange]                                            = useState(1000); // Starting range value
  const [maxRange, setMaxRange]                                            = useState(3000); // Starting range value

  const params                                                             = useParams();
  const [searchParams, setSearchParams]                                    = useSearchParams();

  //locations.
  const [provinceList, setProvinceList]                                     = useState([]);

  //selected Provinces
  const [pageNumber, setPageNumber]                                         = useState(1);
  const [limit, setPageLimit]                                               = useState(9)
 
  useEffect(() => {    
    collectProvinces();
    document.title = 'Shop | Stephenson Adventures';
  },[])
  
  useEffect(() => {
    collectShopList();
  },[searchParams])


  const collectShopList = async () => {
    try{

      var variableString  = "?page=" + pageNumber + "&limit=" + limit;
  
      if(searchParams.get('city')){
        variableString += "&city=" + searchParams.get('city');
      }
      if(searchParams.get('province')){
        variableString += "&province=" + searchParams.get('province');
      }

      console.log("_____------>>>>>")
      console.log(variableString);
      console.log("_____------>>>>>")

      /*
      const resTourList = await axios.get(CONSTANTS.API_URL +"tours/list/", {
          headers: {
            api_key: CONSTANTS.TOKEN_APIKEY
          }
      });
      */
      const resTourList = await axios.get(CONSTANTS.API_URL +"tours/search/multifilter" + variableString, {
            headers: {
              api_key: CONSTANTS.TOKEN_APIKEY
            }
        });

      console.log(resTourList);
      setListProducts(resTourList.data.tourlist);
    }catch(err){
      console.log(err);
    }
  }

  const collectProvinces = async () => {
    try{


      const resProvList = await axios.get(CONSTANTS.API_URL +"tours/provinces/list/v1", {
          headers: {
            api_key: CONSTANTS.TOKEN_APIKEY
          }
      });

      setProvinceList(resProvList.data);
    }catch(err){
      console.log(err);
    }
  }


  // Handler to update fromSlider's value
  const handleFromSliderChange = (event) => {
    const newMinValue = parseInt(event.target.value);
    if (newMinValue <= maxRange) {
      setMinRange(newMinValue);
    }
  };

  // Handler to update toSlider's value
  const handleToSliderChange = (event) => {
    const newMaxValue = parseInt(event.target.value);
    if (newMaxValue >= minRange) {
      setMaxRange(newMaxValue);
    }
  };

  const handlePriceRangeClick = () => {
    //group pricing
    console.log(minRange);
    console.log(maxRange);
  }

  const handleProvinceClick = (province) => {
    // Get the current search parameters
    const params = new URLSearchParams(searchParams);
    // Set the new province
    params.set('province', province);
    // Update the search parameters in the URL
    setSearchParams(params);
  };

  //Clear Filter
  const handleClearFilters = () => {
    const params = new URLSearchParams(searchParams);
    params.delete('province'); // Remove province parameter
    params.delete('city');     // Remove city parameter (optional if you want to clear city too)

    setSearchParams(params);   // Update the URL without the province and city
  };

  return (
    <div className="standard-ountline">
        <div className="standard-area">ShopScreen
           <div className="cont-phase-shop">
              <div className="filter-side">
                 <SideFilter
                    handleFromSliderChange={handleFromSliderChange} 
                    handleToSliderChange={handleToSliderChange} 
                    minRange={minRange}
                    maxRange={maxRange}
                    startLimit={startLimit}
                    endLimit={endLimit}
                    handlePriceRangeClick={handlePriceRangeClick}
                    handleProvinceClick={handleProvinceClick}
                    provinceList={provinceList}
                  />
              </div>
              <div className="main-display">
                  {
                    listProducts &&
                    listProducts.length > 0 && (
                      <div className="row">
                          {
                            listProducts.map((product, index) => {
                              return <div className="col-md-4" key={index}>
                                <Link
                                   to={"/tour/" + product._id}
                                   className="no-linking">
                                    <div className="tab-image-display"
                                      style={{ backgroundImage: `url(${product.img_url})` }}>
                                    </div>
                               </Link>
                               <div className="title-box">
                                 <Link
                                   to={"/tour/" + product._id}
                                   className="no-linking">
                                   {product.name}
                                 </Link>
                               </div>
                               <div className="sub-line">
                                 {product.provinces.map((province, index) => {
                                   return <span key={index}>{province}</span>
                                 })}
                               </div>
                               <div className="price-line">
                                 From <strong>R {parseInt(product.group_price).toFixed(2)}</strong> 
                                 <span className="gr-item">Public Tour</span>
                                 <div className="flright disc-text">Discount: R{product.discount}/2 people+</div>
                               </div>
                           </div>
                            })
                          }
                      </div>
                    )
                  }
                  <div className="strip-filteration">
                      <button className="btn btn-activator" onClick={handleClearFilters}>Reset</button>
                      <div className="right-filt-content">
                          <button className="btn btn-activator">Load More</button>
                      </div>

                  </div>
              </div>


           </div>
        </div>
    </div>
  )
}

export default ShopScreen